module.exports = __webpack_public_path__ + "static/media/tip_goal_inactive.6e91f9bf.svg";